module.exports = __webpack_public_path__ + "static/media/grab.f6af6c4a.cur";